import { Typography } from 'opensolar-ui'
import PropTypes from 'prop-types'
import { useTranslate } from 'ra-core'
import React from 'react'

const style = {
  fontSize: 20,
  fontWeight: 500,
  margin: '10px 0',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  height: 25,
  display: 'flex',
  alignItems: 'center',
}

const Title = ({ defaultTitle, record, title, ...rest }) => {
  const translate = useTranslate()
  if (!title) {
    return <Typography style={style}>{defaultTitle}</Typography>
  }
  if (typeof title === 'string') {
    return <Typography style={style}>{translate(title, { _: title })}</Typography>
  }
  // For React element titles, don't pass the constraining style - let them handle their own height
  return React.cloneElement(title, { record, translate, ...rest })
}

export const TitlePropType = PropTypes.oneOfType([PropTypes.string, PropTypes.element])

Title.propTypes = {
  defaultTitle: PropTypes.string,
  record: PropTypes.object,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
}

export default Title
